module.exports = __webpack_public_path__ + "static/media/made_in_kuban.d03ea86c.png";